/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
import { getQueryParam } from '../routing/getQueryParam';
import { getHistory } from '../routing/history';
export const checkUrlForUUID = () => {
  return Boolean(getQueryParam('uuid'));
};
export const hasAnonQueryParam = () => {
  const anonParam = getQueryParam('anon');
  return anonParam && anonParam === 'true';
};
export const scrubUuidFromUrl = () => {
  const searchParams = new URLSearchParams(getHistory().location.search);
  const uuidFromQueryParam = searchParams.get('uuid');

  if (uuidFromQueryParam) {
    searchParams.delete('uuid');
    getHistory().replace(`${getHistory().location.pathname}?${searchParams}`);
  }
};